import isEmpty from 'is-empty';
import {
  UPLOAD_PROFILE_PHOTO,
  UPLOAD_PROFILE_PHOTO_ERROR,
  UPLOAD_PROFILE_PHOTO_IS_LOADING,
  DELETE_UPLOAD_PROFILE_PHOTO_ERROR,
} from '../../actions/types';

const initialState = {
  success: false,
  uploadPhoto: {},
  error: '',
  loading: false
};

const uploadProfilePhoto = (state = initialState, action) => {
  switch (action.type) {
    case UPLOAD_PROFILE_PHOTO:
      return {
        ...state,
        uploadPhoto: action.profilePhoto,
        success: !isEmpty(action.profilePhoto),
        loading: false
      };
    case UPLOAD_PROFILE_PHOTO_ERROR:
      return {
        ...state,
        error: action.error,
        loading: false
      };
    case DELETE_UPLOAD_PROFILE_PHOTO_ERROR:
      return {
        ...state,
        error: '',
        loading: false
      };
    case UPLOAD_PROFILE_PHOTO_IS_LOADING:
      return {
        ...state,
        loading: true
      };
    default: return state;
  }
};

export default uploadProfilePhoto;
